var _circle, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewGantt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.639 8.33338H6.91669C6.13427 8.33338 5.5 7.69911 5.5 6.91669C5.5 6.13427 6.13427 5.5 6.91669 5.5H11.639C12.4214 5.5 13.0557 6.13427 13.0557 6.91669C13.0557 7.69911 12.4214 8.33338 11.639 8.33338Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0838 13.4446H8.75043C7.96801 13.4446 7.33374 12.8104 7.33374 12.028C7.33374 11.2455 7.96801 10.6113 8.75043 10.6113H14.0838C14.8662 10.6113 15.5005 11.2455 15.5005 12.028C15.5005 12.8104 14.8662 13.4446 14.0838 13.4446Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5276 18.5555H11.8054C11.0229 18.5555 10.3887 17.9212 10.3887 17.1388C10.3887 16.3564 11.0229 15.7221 11.8054 15.7221H16.5276C17.3101 15.7221 17.9443 16.3564 17.9443 17.1388C17.9443 17.9212 17.3101 18.5555 16.5276 18.5555Z",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewGantt);
export default __webpack_public_path__ + "static/media/view_gantt.0cfb5197.svg";
export { ForwardRef as ReactComponent };